module.exports = __webpack_public_path__ + "img/face19.2ecf6cad.jpg";